import Axios from 'axios';
import { allStates } from '../enums/state';
import { isEqual } from 'lodash';

const urls = {
    controller: {
        locations: '/api/locations',
        states: '/api/player/states',
    },
    designer: {
        locations: '/api/locations',
        states: '/api/states',
    },
};

const dataLoadMiddleware = async (store, to, from, next, types, appType) => {
    store.dispatch('setLoading', true);

    if (store.state.user) {
        const requestConfig = store.state.token ? {
            headers: {
                Authorization: `Bearer ${store.state.token}`,
            },
        } : {};

        if (types.indexOf('locations') !== -1 && store.state.locations === null) {
            const response = await Axios.get(urls[appType].locations, requestConfig);

            store.dispatch('setLocations', response.data);
        }

        if (types.indexOf('states') !== -1 && store.state.states === null) {
            // No need to load this from the backend since it will probably never change
            store.dispatch('setStates', allStates);
        }
    }

    const companyContext = {
        hostname: window.location.hostname,
        user_token: store.state.token,
        ceremony_code: to.name === 'blocks' ? to.params.code : null,
    };

    if (types.indexOf('companySettings') !== -1 && !isEqual(store.state.companySettingsContext, companyContext)) {
        await store.dispatch('loadCompanySettings', companyContext);
    }

    store.dispatch('setLoading', false);

    return next();
};

export default dataLoadMiddleware;
